import script from "./FailedProductsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FailedProductsModal.vue?vue&type=script&setup=true&lang=js"

import "./FailedProductsModal.vue?vue&type=style&index=0&id=25406ede&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25406ede"]])

export default __exports__